import { initialScheduleFormData } from 'containers/Scheduling/RightDrawer/ScheduleForm/schema';
import { repeatTypeOptions, days } from 'global/options';

export const transformScheduleDataToFormData = (schedule: any): typeof initialScheduleFormData => {
  const formData: typeof initialScheduleFormData = {
    ...initialScheduleFormData,
    id: schedule?.id || '',
    title: schedule?.title || '',
    event_pid: schedule?.event_pid || '',
    description: schedule?.description || '',
    start_date: schedule?.timezone_dateinfo
      ? new Date(schedule?.timezone_dateinfo?.start_date)
      : schedule?.start_date
        ? new Date(schedule.start_date)
        : undefined,
    end_date: schedule?.timezone_dateinfo
      ? new Date(schedule?.timezone_dateinfo?.end_date)
      : schedule?.end_date
        ? new Date(schedule.end_date)
        : undefined,
    start_time: schedule?.timezone_dateinfo ? schedule?.timezone_dateinfo?.start_time : schedule?.start_time || '',
    end_time: schedule?.timezone_dateinfo ? schedule?.timezone_dateinfo?.end_time : schedule?.end_time || '',
    job_id: schedule?.job_id
      ? { id: schedule.job_id, name: schedule?.job_name, address: schedule?.address || {} }
      : null,
    color: schedule?.color_hex_code || undefined,
    all_day: schedule?.all_day ? ['yes'] : [],
    repeat: schedule?.repeat ? ['yes'] : [],
    publish: schedule?.is_publish ? true : false,
    repeat_type: schedule?.rec_type ? repeatTypeOptions.find((item: any) => item.value === schedule.rec_type) : '',
    repeat_start_date: schedule?.repeat_start_date ? new Date(schedule.repeat_start_date) : undefined,
    repeat_end_date: schedule?.repeat_date ? new Date(schedule.repeat_date) : undefined,
    weeks:
      Array.isArray(schedule?.weeks) && schedule?.weeks.length
        ? days.filter((item: any) => schedule.weeks.includes(item.value))
        : [],
    user_ids: Array.isArray(schedule?.assignee)
      ? schedule.assignee.map((item: any) => ({ ...item, userId: item?.userId }))
      : [],
    group_ids: [],
    update_series: false,
    street: schedule?.address?.street || '',
    city: schedule?.address?.city || '',
    state: schedule?.address?.state || '',
    country: schedule?.address?.country || '',
    zipCode: schedule?.address?.zip || '',
    show_address: schedule?.use_different_address ? ['yes'] : [],
    timezone: schedule?.timezone,
  };

  return formData;
};
